import { BaseModel } from "../Generics/BaseModel"
import { CatalogProductEntity } from "./CatalogProductEntity"

export class CatalogItemEntity extends BaseModel {
  id: number
  catalogProductEntity: CatalogProductEntity

  constructor(data: Partial<CatalogItemEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.catalogProductEntity = new CatalogProductEntity(data.catalogProductEntity)
  }
}
